const primaryButtonVariants = {
  v1: "v1",
  v2: "v2",
}

export default primaryButtonVariants
